import styled from 'styled-components';

export const SectionDivider = styled.hr`
  margin: 40px 0 30px 0;
  border: none;
  border-top: 2px solid #dee6f2;
`;

export const SectionTitle = styled.h3`
  font-family: Poppins;
  font-size: 18px;
  font-weight: 600;
  color: var(--midnight-blue);
  margin-bottom: 20px;
`;
